// eslint-disable-next-line import/prefer-default-export
export function buildSummary(conditions) {
  let summary = '';
  let preRelation = null;
  for (let i = 0; i < conditions.length; i += 1) {
    const currentCondition = conditions[i];
    const currentConditionText = `${currentCondition.condition} ${currentCondition.operator} ${currentCondition.value}`;
    if (currentCondition.condition.length > 0 && currentCondition.operator.length > 0 && currentCondition.value.length > 0) {
      if (currentCondition.children !== undefined) {
        const childrenSummary = buildSummary(currentCondition.children); // Recursive Call
        let tempSummary = '';
        if (currentCondition.relation.length > 0 && childrenSummary.length > 0) {
          if (currentCondition.relation.toLowerCase() === 'or') {
            tempSummary += `${currentConditionText} OR ${childrenSummary}`;
          } else {
            tempSummary += `${currentConditionText} AND ${childrenSummary}`;
          }
        } else {
          tempSummary += `${currentConditionText}`;
        }
        if (preRelation) {
          if (preRelation.toLowerCase() === 'or') {
            summary += 'OR ';
          } else {
            summary += 'AND ';
          }
        }
        summary += `( ${tempSummary} ) `;
        preRelation = currentCondition.groupRelation;
      } else {
        if (preRelation) {
          if (preRelation.toLowerCase() === 'or') {
            summary += 'OR ';
          } else {
            summary += 'AND ';
          }
        }
        summary += `${currentConditionText} `;
        preRelation = currentCondition.relation;
      }
    }
  }
  return summary;
}
